import { PathRequestProgressStatusEnum } from '@elearning-platform/api-types/enums';

import { ProgressStatusFilterValue } from '../../types/common';

export const progressStatusFilterToApiStatusesMap: Record<ProgressStatusFilterValue, PathRequestProgressStatusEnum[]> = {
  [PathRequestProgressStatusEnum.PreFormOpen]: [
    PathRequestProgressStatusEnum.PreFormOpen,
  ],
  [PathRequestProgressStatusEnum.PreFormInProgress]: [
    PathRequestProgressStatusEnum.PreFormInProgress,
    PathRequestProgressStatusEnum.PreFormInRetakeProgress,
  ],
  [PathRequestProgressStatusEnum.PreFormWaitingForReview]: [
    PathRequestProgressStatusEnum.PreFormWaitingForReview,
    PathRequestProgressStatusEnum.PreFormWaitingForRetakeReview,
  ],
  [PathRequestProgressStatusEnum.PreFormInReview]: [
    PathRequestProgressStatusEnum.PreFormInReview,
    PathRequestProgressStatusEnum.PreFormInRetakeReview,
  ],
  [PathRequestProgressStatusEnum.PreFormRejected]: [
    PathRequestProgressStatusEnum.PreFormRejected,
    PathRequestProgressStatusEnum.PreFormRejectedInRetake,
  ],
  [PathRequestProgressStatusEnum.FileDownloadPending]: [
    PathRequestProgressStatusEnum.FileDownloadPending,
  ],
  [PathRequestProgressStatusEnum.DataFormOpen]: [
    PathRequestProgressStatusEnum.DataFormOpen,
  ],
  [PathRequestProgressStatusEnum.DataFormInProgress]: [
    PathRequestProgressStatusEnum.DataFormInProgress,
    PathRequestProgressStatusEnum.DataFormInRetakeProgress,
  ],
  [PathRequestProgressStatusEnum.DataFormWaitingForReview]: [
    PathRequestProgressStatusEnum.DataFormWaitingForReview,
    PathRequestProgressStatusEnum.DataFormWaitingForRetakeReview,
  ],
  [PathRequestProgressStatusEnum.DataFormInReview]: [
    PathRequestProgressStatusEnum.DataFormInReview,
    PathRequestProgressStatusEnum.DataFormInRetakeReview,
  ],
  [PathRequestProgressStatusEnum.DataFormRejected]: [
    PathRequestProgressStatusEnum.DataFormRejected,
    PathRequestProgressStatusEnum.DataFormRejectedInRetake,
  ],
  [PathRequestProgressStatusEnum.CourseMaterialsOpen]: [
    PathRequestProgressStatusEnum.CourseMaterialsOpen,
  ],
  [PathRequestProgressStatusEnum.UploadFormOpen]: [
    PathRequestProgressStatusEnum.UploadFormOpen,
  ],
  [PathRequestProgressStatusEnum.UploadFormInProgress]: [
    PathRequestProgressStatusEnum.UploadFormInProgress,
    PathRequestProgressStatusEnum.UploadFormInRetakeProgress,
  ],
  [PathRequestProgressStatusEnum.UploadFormWaitingForReview]: [
    PathRequestProgressStatusEnum.UploadFormWaitingForReview,
    PathRequestProgressStatusEnum.UploadFormWaitingForRetakeReview,
  ],
  [PathRequestProgressStatusEnum.UploadFormInReview]: [
    PathRequestProgressStatusEnum.UploadFormInReview,
    PathRequestProgressStatusEnum.UploadFormInRetakeReview,
  ],
  [PathRequestProgressStatusEnum.UploadFormRejected]: [
    PathRequestProgressStatusEnum.UploadFormRejected,
    PathRequestProgressStatusEnum.UploadFormRejectedInRetake,
  ],
  [PathRequestProgressStatusEnum.ExamRegistrationOpen]: [
    PathRequestProgressStatusEnum.ExamRegistrationOpen,
    PathRequestProgressStatusEnum.ExamRegistrationRetakeOpen,
    PathRequestProgressStatusEnum.ExamRegistrationRescheduleOpen,
  ],
  [PathRequestProgressStatusEnum.ExamRegistrationPending]: [
    PathRequestProgressStatusEnum.ExamRegistrationPending,
    PathRequestProgressStatusEnum.ExamRegistrationRetakePending,
  ],
  [PathRequestProgressStatusEnum.ExamTypeAssignmentOpen]: [
    PathRequestProgressStatusEnum.ExamTypeAssignmentOpen,
  ],
  [PathRequestProgressStatusEnum.ExamResultsOpen]: [
    PathRequestProgressStatusEnum.ExamResultsOpen,
  ],
  [PathRequestProgressStatusEnum.ExamResultsInReview]: [
    PathRequestProgressStatusEnum.ExamResultsInReview,
  ],
  [PathRequestProgressStatusEnum.AuthorizationUploadOpen]: [
    PathRequestProgressStatusEnum.AuthorizationUploadOpen,
  ],
  [PathRequestProgressStatusEnum.Finished]: [
    PathRequestProgressStatusEnum.Finished,
  ],
  [PathRequestProgressStatusEnum.SystemProcessing]: [
    PathRequestProgressStatusEnum.SystemProcessing,
  ],
};
